import axios from 'axios';

const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (window.location.port === '3000' ? 'http://localhost:3001' : '');

const toDateParam = (date) => (date ? date.toISOString().split('T')[0] : null);

export const buildPieChartParams = ({ startDate, endDate, ateSwVersion, selectedSerialNumbers, selectedFamilies = [] }) => ({
    startDate: toDateParam(startDate),
    endDate: toDateParam(endDate),
    ateSwVersion: ateSwVersion || null,
    serialNumbers: selectedSerialNumbers.map((serialNumber) => serialNumber.value),
    selectedFamilies,
});

export const fetchUutStatusCount = async (params) => {
    const response = await axios.get(`${API_BASE}/api/uut-status-count`, { params });
    return response.data;
};

export const fetchTotalProduction = async (params) => {
    const response = await axios.get(`${API_BASE}/api/total-production`, { params });
    return response.data.totalProduction;
};

export const fetchUutStatusDetails = async (params) => {
    const response = await axios.get(`${API_BASE}/api/uut-status-details`, { params });
    return response.data.sort((a, b) => b.count - a.count);
};

export const fetchAteSwVersions = async () => {
    const response = await axios.get(`${API_BASE}/api/ate-sw-versions`);
    return response.data.map((version) => ({
        value: version.AteSwVersion,
        label: version.AteSwVersion,
    }));
};

export const fetchSerialNumbers = async () => {
    const response = await axios.get(`${API_BASE}/api/distinct-serial-numbers`);
    return response.data.map((serialNumber) => ({
        value: serialNumber,
        label: serialNumber,
    }));
};
